module.exports = __webpack_public_path__ + "static/media/talia.f660d5cd.jpeg";